/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Each_Legal_Hound_ArriveInputs */

const es_each_legal_hound_arrive = /** @type {(inputs: Each_Legal_Hound_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`personas`)
};

const gl_each_legal_hound_arrive = /** @type {(inputs: Each_Legal_Hound_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`persoas`)
};

const en_each_legal_hound_arrive = /** @type {(inputs: Each_Legal_Hound_ArriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`people`)
};

/**
* | output |
* | --- |
* | "people" |
*
* @param {Each_Legal_Hound_ArriveInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const each_legal_hound_arrive = /** @type {((inputs?: Each_Legal_Hound_ArriveInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Each_Legal_Hound_ArriveInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_each_legal_hound_arrive(inputs)
	if (locale === "en") return en_each_legal_hound_arrive(inputs)
	return es_each_legal_hound_arrive(inputs)
});